import React from 'react';
import s from './s.module.less';
import { Button, message, Checkbox } from 'antd';
import GlobalLayerStore from 'store/GlobalLayer';
import { Channel } from 'types/common';
import { getChannelPayLink } from 'api/subscription';
import { setPendingSubscriptionChannel } from 'utils/localstore';
import { isDevEnv } from 'utils/common';
import dayjs from 'utils/dayjs';

type IProps = {
    onConfirm?: () => void;
};

const PlatformAgreementUrl = isDevEnv()
    ? 'https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/agreement/platform-access-and-services-2025052201.html'
    : 'https://saas-prod-us.s3.us-east-2.amazonaws.com/prod/agreement/platform-access-and-services-2025052201.html';

const PPAChannelSubscription = (props: IProps) => {
    const [loading, setLoading] = React.useState(false);
    const [getGlobalLayer] = GlobalLayerStore.useStore();
    const channel: Channel | undefined = getGlobalLayer('pendingSubscriptionChannel');
    const [checked, setChecked] = React.useState(true);
    const { onConfirm } = props;

    let period = 'month';
    if (channel?.billingCycle === 'Quarterly') {
        period = 'quarter';
    }
    if (channel?.billingCycle === 'Yearly') {
        period = 'year';
    }
    const freeTrial = !!(channel?.freeTrialDays && channel?.freeTrialDays > 0);
    return (
        <div className={s.wrap}>
            <div className={s.logoWrap}>
                <div className={s.left}>
                    <img src={channel?.logo} />
                </div>
                <div className={s.descWrap}>
                    <div className={s.name}>Join {channel?.name}</div>
                    <div className={s.desc}>Per appointment billing</div>
                </div>
            </div>
            <div className={s.advantage}>
                <div className={s.titleText}>
                    Pay only when a patient books an appointment, never leads
                </div>
                <ul className={s.advantageList}>
                    <li className={s.advantageItem}>No subscription or monthly fees</li>
                    <li className={s.advantageItem}>
                        Protected from no-shows — set your own cancellation fee
                    </li>
                    <li className={s.advantageItem}>
                        We collect patient credit card details to secure your appointments
                        (powered by Stripe)
                    </li>
                    <li className={s.advantageItem}>
                        We don’t charge for follow-up appointments
                    </li>
                </ul>
            </div>

            <div className={s.billing}>
                <div className={s.billingHeader}>
                    <h3 className={s.billingTitle}>{channel?.name}</h3>
                    <div className={s.billingPrice}>$80 per appointment</div>
                </div>
                <div className={s.billingDesc}>
                    You only pay when a patient books their initial appointment. No
                    hidden costs. Payments are processed automatically via Stripe.
                </div>
            </div>

            <div className={s.premiumChannel}>
                <Checkbox
                    checked={checked}
                    onChange={() => setChecked(!checked)}
                    className="mb-6"
                >
                    By checking this box, I agree to the{' '}
                    <a href={PlatformAgreementUrl} target="_blank" rel="noreferrer" className={s.link}>
                        Klarity Health Platform Agreement
                    </a>{' '}
                    outlined in the agreement on{' '}
                    {dayjs(new Date().getTime()).format('YYYY-MM-DD')}.
                </Checkbox>
            </div>

            <div className={s.btnWrap}>
                <Button
                    onClick={async () => {
                        if (!channel?.subscriptionPriceId) {
                            message.error('Plan not set');
                            return;
                        }
                        setLoading(true);
                        const result = await getChannelPayLink(channel.id);
                        if (!result.error) {
                            const link = result.data.data;
                            if (link) {
                                setPendingSubscriptionChannel(channel);
                                onConfirm?.();
                                window.open(link, '_self');
                            } else {
                                message.error('Pay link not found');
                            }
                        }

                        setLoading(false);
                    }}
                    block
                    size="large"
                    type="primary"
                    className={s.btn}
                    loading={loading}
                    disabled={!checked}
                >
                    Confirm
                </Button>
                <div className={s.tips}>
                    By confirming, you authorize the payment using your saved info via
                    Stripe, ensuring a secure transaction.
                </div>
                <div className={s.power} />
            </div>
        </div>
    );
};

export default PPAChannelSubscription;
